import gql from 'graphql-tag';

export default function(device)
{
    this.$apollo.mutate(
        {
            mutation: gql`mutation s($input: StartDeviceDiscoveryInput!) { startDeviceDiscovery(input: $input) }`,
            variables:
            {
                input: {id: device.id}
            }
        }
    ).then(() => console.log('Discovery started'));
}